//@flow

import * as React from "react"
import { FormattedMessage } from "react-intl"
import styled from "styled-components"
import { TweenMax, Back, Cubic } from "gsap"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-align: center;
  margin: auto;
`

const Title = styled.h1`
  font-size: 60px;
  color: #00b1ec;
  font-family: "din-condensed";
  font-weight: 400;
  font-size: 120px;
  margin: -1rem auto 0 auto;
  padding: 0;
  line-height: 1em;
  text-align: center;
  text-transform: uppercase;
`

const SubTitle = Title.extend`
  color: #0f2d49;
  font-size: 200px;
`

type Props = { titleKey: string }

class FormattedTitles extends React.Component<Props> {
  titles: HTMLElement[]

  constructor(props: Props) {
    super(props)
    this.titles = []
  }

  componentDidMount() {
    this.pulse()
  }

  componentDidUpdate(prevProps: Props) {
    const { titleKey } = this.props
    if (prevProps.titleKey !== titleKey) {
      this.pulse()
    }
  }

  pulse = () => {
    const titles = this.titles.filter(el => el !== null)
    TweenMax.set(titles, { y: -100, opacity: 0 })
    TweenMax.staggerTo(titles, 1, { y: 0, ease: Back.easeOut }, 0.35)
    TweenMax.staggerTo(titles, 1, { opacity: 1, ease: Cubic.easeOut }, 0.35)
  }

  render() {
    const { titleKey } = this.props
    return (
      <Container>
        <Title innerRef={el => this.titles.push(el)}>
          <FormattedMessage id={`kiosk.home.loop.title.${titleKey}`} />
        </Title>
        <SubTitle innerRef={el => this.titles.push(el)}>
          <FormattedMessage id={`kiosk.home.loop.subtitle.${titleKey}`} />
        </SubTitle>
      </Container>
    )
  }
}

export default FormattedTitles



// WEBPACK FOOTER //
// ./src/Kiosk/AttractLoopView/FormattedTitles.js